// extracted by mini-css-extract-plugin
export default {"root":"MessageDefault_root__yq95+","content":"MessageDefault_content__WXCG-","message":"MessageDefault_message__KoDOr","action":"MessageDefault_action__q+ylu"};